import axios from "axios";
import Highcharts from "highcharts/highmaps";

const fetchGeoDataForHcKey = async (hcKey: string): Promise<Highcharts.GeoJSON> => {
  if (!Highcharts.maps[hcKey]) {
    const { data } = await axios.get(`https://code.highcharts.com/mapdata/${hcKey}.geo.json`);

    Highcharts.maps[hcKey] = data;
  }

  return Highcharts.maps[hcKey];
};

export default fetchGeoDataForHcKey;
